import { EntityState } from '@ngrx/entity';

export interface sapiensEntityState<T> extends EntityState<T> {
  meta: Meta;
}

export interface Meta {
  sliceState: SliceState,
  isReportable?: boolean,
  timestamp?: number,
  issuerStack?: string[]
}

export enum SliceState {
  total = 'total',
  reportable = 'reportable',
  inital = 'inital',
}
